// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc_body_content {
    width: 100%;
    height: 100vh;
}

.company_name {
    font-size: 22px;
    margin-top: 55px;
    text-align: center;
    color: #004ba0;
}

.title {
    font-size: 28px;
    text-align: center;
    margin-bottom: 55px;
    color: #004ba0;
}

#last_modified {
    margin-top: 15px;
    color: #00000066;
}

.content {
    width: 60%;
    padding-left: 20%;
    padding-right: 20%;

}

.content_title {
    margin-bottom: 0;
    padding-top: 5%;
    text-align: left;
    color: #424242;
    font-size: 25px;
}

.rc_body_content p {
    margin-top: 0;
    padding-top: 10px;
    text-align: justify;
    font-size: 18px;
    color: #424242;
    line-height: 25px;
}

.rc_body_content h3 {
    color: #212121;
    text-align: center;
    margin-top: 50px;
}

@media screen and (max-width: 550px) {

    .content {
        width: 80%;
        padding-left: 10%;
        padding-right: 10%;
    }

    .company_name {
        font-size: 20px;
    }

    .title {
        font-size: 25px;
    }

    .content_title {
        font-size: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/home/css/rc-policy.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI;QACI,UAAU;QACV,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".rc_body_content {\n    width: 100%;\n    height: 100vh;\n}\n\n.company_name {\n    font-size: 22px;\n    margin-top: 55px;\n    text-align: center;\n    color: #004ba0;\n}\n\n.title {\n    font-size: 28px;\n    text-align: center;\n    margin-bottom: 55px;\n    color: #004ba0;\n}\n\n#last_modified {\n    margin-top: 15px;\n    color: #00000066;\n}\n\n.content {\n    width: 60%;\n    padding-left: 20%;\n    padding-right: 20%;\n\n}\n\n.content_title {\n    margin-bottom: 0;\n    padding-top: 5%;\n    text-align: left;\n    color: #424242;\n    font-size: 25px;\n}\n\n.rc_body_content p {\n    margin-top: 0;\n    padding-top: 10px;\n    text-align: justify;\n    font-size: 18px;\n    color: #424242;\n    line-height: 25px;\n}\n\n.rc_body_content h3 {\n    color: #212121;\n    text-align: center;\n    margin-top: 50px;\n}\n\n@media screen and (max-width: 550px) {\n\n    .content {\n        width: 80%;\n        padding-left: 10%;\n        padding-right: 10%;\n    }\n\n    .company_name {\n        font-size: 20px;\n    }\n\n    .title {\n        font-size: 25px;\n    }\n\n    .content_title {\n        font-size: 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
